import { turbine } from "neql"
import { useMemo } from "react"
import { QualifierCardMetricModel } from "../Models/API/QualifierModel"

function getNumQuestionsMetric(value: string, type: turbine.TrainingType) {
    const singular = value === "1"
    const description =
        type === turbine.TrainingType.Test
            ? `Question${singular ? "" : "s"} per labeler`
            : `Step${singular ? "" : "s"}`

    return {
        description,
        value
    }
}

function getNumFinishedMetric(value: string) {
    const singular = value === "1"
    const description = `${singular ? "Person" : "People"} finished`

    return {
        description,
        value
    }
}

function getNumPassedMetric(value: string) {
    const singular = value === "1"
    const description = `${singular ? "Person" : "People"} passed`

    return {
        description,
        value
    }
}

function getDropOffRateMetric(totalStarted: number, totalFinished: number) {
    return {
        description: "Drop-off rate",
        value:
            totalStarted > 0
                ? Math.round((1 - totalFinished / totalStarted) * 100) + "%"
                : "N/A"
    }
}

export function useQualifierCardMetric(
    stats: turbine.TrainingStatistics | undefined | null,
    baselineTotal: number,
    qualifierNumQuestions: string,
    type: turbine.TrainingType
): QualifierCardMetricModel[] {
    return useMemo(() => {
        if (stats === undefined || stats === null) {
            return []
        }

        const aggregateMetrics = [
            getNumQuestionsMetric(qualifierNumQuestions, type),
            getNumFinishedMetric(stats.numFinished.toString()),
            ...(type === turbine.TrainingType.Test
                ? [getNumPassedMetric(stats.numPassed.toString())]
                : []),
            getDropOffRateMetric(
                stats.numStarted + stats.numFinished + stats.numCancelled, // numStarted tells the number who have started but not in a terminal state
                stats.numFinished
            )
        ]

        if (type === turbine.TrainingType.Test) {
            aggregateMetrics.splice(1, 0, {
                description: "Question pool size",
                value: String(baselineTotal)
            })
        }

        return aggregateMetrics
    }, [baselineTotal, qualifierNumQuestions, stats, type])
}
